import { MouseBlocker } from "@lib/titan2/dist/game/control/MouseBlocker";
import { TitanButton } from "@lib/titan2/dist/game/control/TitanButton";
import { TitanSpine } from "@lib/titan2/dist/game/control/TitanSpine";
import { ButtonConstants, ControlConstants, } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { ButtonProperties } from "@lib/titan2/dist/game/control/properties/ButtonProperties";
import { FontShadow, FontStroke, } from "@lib/titan2/dist/game/control/properties/FontProperties";
import { MouseBlockerProperties } from "@lib/titan2/dist/game/control/properties/MouseBlockerProperties";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
import { SoundChannelType } from "@lib/titan2/dist/game/controller/type/SoundChannelType";
import { SoundManager } from "@lib/titan2/dist/game/manager/SoundManager";
import { TrackingProperties, } from "@lib/titan2/dist/game/renderer/Renderer";
import { OrientationType } from "@lib/titan2/dist/game/renderer/constant/RendererConstants";
import { AbstractView } from "@lib/titan2/dist/game/view/AbstractView";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { KeyValuePair } from "@lib/titan2/dist/util/collection/KeyValuePair";
import { EventObject } from "@lib/titan2/dist/util/event/EventObject";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { DestroyUtil } from "@lib/titan2/dist/util/view/DestroyUtil";
import { GraphicsUtil } from "@lib/titan2/dist/util/view/GraphicsUtil";
import { SpineUtil } from "@lib/titan2/dist/util/view/SpineUtil";
import { ViewUtils } from "@lib/titan2/dist/util/view/ViewUtils";
import { Back, gsap } from "gsap";
import * as PIXI from "pixi.js";
import { Service } from "../../../../api/Service";
import { SlingoEvent } from "../../../controller/event/SlingoEvent";
import { SlingoLang } from "../lang/SlingoLang";
import { SlingoStyle } from "../style/SlingoStyle";
import { AbstractGameView } from "./AbstractGameView";
/**
 * ArcadeWheel.ts
 */
export class ArcadeWheel extends AbstractGameView {
    constructor() {
        super(...arguments);
        this.__tweenID = 0;
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(ArcadeWheelEvent.SHOW, this.handleShow);
        this.registerGame(ArcadeWheelEvent.REPLAY_SPIN, this.handleReplay);
        this.registerGame(ArcadeWheelEvent.HIDE, this.handleHide);
        this.registerGame(CommonGameEvent.COLLECT_REQUEST, this.handleHide);
        this.registerGame(ArcadeWheelEvent.STAKE_TO_SPIN_RESULT, this.handleStakeToSpinResult);
        this.registerGame(SlingoEvent.PAY_TABLE_OPEN, this.handlePayTableOpen);
        this.registerGame(SlingoEvent.PAY_TABLE_CLOSE, this.handlePayTableClose);
        this.registerGame(CommonGameEvent.REPLAY_STOP, this.handleHide);
        this.registerGame(CommonGameEvent.HELP_DIALOG_OPEN, this.handleHelpDialogOpen);
        this.registerGame(CommonGameEvent.HELP_DIALOG_CLOSE, this.handleHelpDialogClose);
    }
    removeEventListeners() {
        super.removeEventListeners();
        this.unregisterGame(ArcadeWheelEvent.SHOW);
        this.unregisterGame(ArcadeWheelEvent.REPLAY_SPIN);
        this.unregisterGame(ArcadeWheelEvent.HIDE);
        this.unregisterGame(CommonGameEvent.COLLECT_REQUEST);
        this.unregisterGame(ArcadeWheelEvent.STAKE_TO_SPIN_RESULT);
        this.unregisterGame(SlingoEvent.PAY_TABLE_OPEN);
        this.unregisterGame(SlingoEvent.PAY_TABLE_CLOSE);
        this.unregisterGame(CommonGameEvent.REPLAY_STOP);
        this.unregisterGame(CommonGameEvent.HELP_DIALOG_OPEN);
        this.unregisterGame(CommonGameEvent.HELP_DIALOG_CLOSE);
    }
    create() {
        super.create();
        this.createInstructions();
        this.container = ViewUtils.createContainer(this, "Wheel");
        this.createAnimation();
        this.createActionButton();
        this.createSpinCounter();
        this.createQuestionButton();
        this.createToolTip();
        this.hackToolTipPosition();
        this.createAnchor();
    }
    postCreate() {
        super.postCreate();
        Logger.addObjectRef(this, "ArcadeWheel");
        this.state = ArcadeWheelState.HIDDEN;
        this.qButtonCallToActionShown = false;
        this.tweenPosition(false);
        this.handleHide();
    }
    createAnimation() {
        this.animation = TitanSpine.createSpine(this.container, this.landscapeProperties.animationProperties, this.portraitProperties?.animationProperties);
    }
    createActionButton() {
        if (!this.imageExists(this.landscapeProperties.actionButtonProperties.id, this.landscapeProperties.actionButtonProperties.spriteSheet)) {
            const circleR = this.landscapeProperties.actionButtonProperties.circleRadius;
            let g = new PIXI.Graphics();
            g.beginFill(0x000000, 0.00001);
            g.drawCircle(0, 0, circleR);
            g.endFill();
            const texName = this.landscapeProperties.actionButtonProperties.spriteSheet +
                "-" +
                this.landscapeProperties.actionButtonProperties.id +
                "Up";
            PIXI.Texture.addToCache(this.renderer.getRenderer().generateTexture(g, {
                scaleMode: PIXI.SCALE_MODES.LINEAR,
                resolution: 1,
            }), texName);
        }
        this.actionButton = TitanButton.createButton(this.container, this.landscapeProperties.actionButtonProperties, this.portraitProperties?.actionButtonProperties, this.handleActionButtonClick.bind(this));
        this.actionButton.onMouseDown(this.handleButtonDown, this);
        this.actionButton.onMouseOut(this.handleButtonOut, this);
        this.actionButton.onMouseOver(this.handleButtonOver, this);
        this.spinPrice = ViewUtils.createField(this.actionButton, this.landscapeProperties.spinPriceProperties, this.portraitProperties?.spinPriceProperties);
        this.actionButton.setEnabled(false);
    }
    createSpinCounter() {
        this.spinCounterText = ViewUtils.createField(this.actionButton, this.landscapeProperties.spinCounterTextProperties, this.portraitProperties?.spinCounterTextProperties);
        this.updateSpinCounter();
    }
    createQuestionButton() {
        if (!this.imageExists(this.landscapeProperties.qButtonProperties.id, this.landscapeProperties.qButtonProperties.spriteSheet)) {
            const circleR = this.landscapeProperties.qButtonProperties.circleRadius;
            let g = new PIXI.Graphics();
            g.beginFill(0x000000, 0.00001);
            g.drawCircle(0, 0, circleR);
            g.endFill();
            const texName = this.landscapeProperties.qButtonProperties.spriteSheet +
                "-" +
                this.landscapeProperties.qButtonProperties.id +
                "Up";
            PIXI.Texture.addToCache(this.renderer.getRenderer().generateTexture(g, {
                scaleMode: PIXI.SCALE_MODES.LINEAR,
                resolution: 1,
            }), texName);
        }
        this.qButton = TitanButton.createButton(this.container, this.landscapeProperties.qButtonProperties, this.portraitProperties?.qButtonProperties, this.handleQButtonClick.bind(this));
        this.qButton.onMouseDown(this.handleQButtonDown, this);
        this.qButton.onMouseOut(this.handleQButtonOut, this);
        this.qButton.onMouseOver(this.handleQButtonOver, this);
        this.qButton.setEnabled(false);
    }
    createInstructions() {
        this.instructionsText = ViewUtils.createField(this, this.landscapeProperties.instructionsProperties, this.portraitProperties.instructionsProperties);
        this.instructionsBackground = new TitanSpine(this.landscapeProperties.instructionsBackgroundProperties, this.portraitProperties.instructionsBackgroundProperties);
        SpineUtil.play(this.instructionsBackground, ArcadeWheelStyle.ANIM_INSTRUCTIONS_BACKGROUND);
        this.instructionsText.addChildAt(this.instructionsBackground, 0);
    }
    async createToolTip() {
        const toolTipWheelInfoTextLandscape = ViewUtils.createField(this, this.uiProperties.toolTipWheelInfoTextLandscapeProperties);
        const toolTipCounterInfoTextLandscape = ViewUtils.createField(this, this.uiProperties.toolTipCounterInfoTextLandscapeProperties);
        const toolTipWheelInfoTextPortrait = ViewUtils.createField(this, this.uiProperties.toolTipWheelInfoTextPortraitProperties);
        const toolTipCounterInfoTextPortrait = ViewUtils.createField(this, this.uiProperties.toolTipCounterInfoTextPortraitProperties);
        const toolTipWheelWinText = ViewUtils.createField(this, this.uiProperties.toolTipWheelWinTextProperties);
        const toolTipWheelLoseText = ViewUtils.createField(this, this.uiProperties.toolTipWheelLoseTextProperties);
        const toolTipCounterWinText = ViewUtils.createField(this, this.uiProperties.toolTipCounterWinTextProperties);
        const toolTipCounterLoseText = ViewUtils.createField(this, this.uiProperties.toolTipCounterLoseTextProperties);
        this.mouseBlocker = new MouseBlocker(new MouseBlockerProperties(0x000000, 0.0001, true));
        this.mouseBlocker.onClick(this.handleQButtonClick, this);
        this.addChildAt(this.mouseBlocker, 0);
        this.mouseBlocker.visible = false;
        //force init of textfields
        toolTipWheelInfoTextLandscape.getPixiText();
        toolTipCounterInfoTextLandscape.getPixiText();
        toolTipWheelInfoTextPortrait.getPixiText();
        toolTipCounterInfoTextPortrait.getPixiText();
        toolTipWheelWinText.getPixiText();
        toolTipWheelLoseText.getPixiText();
        toolTipCounterWinText.getPixiText();
        toolTipCounterLoseText.getPixiText();
        await gsap.delayedCall(0, () => {
            this.toolTipWheelInfoTextureLandscape = PIXI.RenderTexture.create({
                width: this.uiProperties.toolTipWheelInfoTextLandscapeProperties.size.x,
                height: this.uiProperties.toolTipWheelInfoTextLandscapeProperties.size.y,
            });
            this.toolTipCounterInfoTextureLandscape = PIXI.RenderTexture.create({
                width: this.uiProperties.toolTipCounterInfoTextLandscapeProperties.size.x,
                height: this.uiProperties.toolTipCounterInfoTextLandscapeProperties.size.y,
            });
            this.toolTipWheelInfoTexturePortrait = PIXI.RenderTexture.create({
                width: this.uiProperties.toolTipWheelInfoTextPortraitProperties.size.x,
                height: this.uiProperties.toolTipWheelInfoTextPortraitProperties.size.y,
            });
            this.toolTipCounterInfoTexturePortrait = PIXI.RenderTexture.create({
                width: this.uiProperties.toolTipCounterInfoTextPortraitProperties.size.x,
                height: this.uiProperties.toolTipCounterInfoTextPortraitProperties.size.y,
            });
            this.toolTipWheelWinTexture = PIXI.RenderTexture.create({
                width: this.uiProperties.toolTipWheelWinTextProperties.size.x,
                height: this.uiProperties.toolTipWheelWinTextProperties.size.y,
            });
            this.toolTipWheelLoseTexture = PIXI.RenderTexture.create({
                width: this.uiProperties.toolTipWheelLoseTextProperties.size.x,
                height: this.uiProperties.toolTipWheelLoseTextProperties.size.y,
            });
            this.toolTipCounterWinTexture = PIXI.RenderTexture.create({
                width: this.uiProperties.toolTipCounterWinTextProperties.size.x,
                height: this.uiProperties.toolTipCounterWinTextProperties.size.y,
            });
            this.toolTipCounterLoseTexture = PIXI.RenderTexture.create({
                width: this.uiProperties.toolTipCounterLoseTextProperties.size.x,
                height: this.uiProperties.toolTipCounterLoseTextProperties.size.y,
            });
            this.renderer.getRenderer().render(toolTipWheelInfoTextLandscape, {
                renderTexture: this.toolTipWheelInfoTextureLandscape,
                clear: true,
            });
            this.renderer.getRenderer().render(toolTipCounterInfoTextLandscape, {
                renderTexture: this.toolTipCounterInfoTextureLandscape,
                clear: true,
            });
            this.renderer.getRenderer().render(toolTipWheelInfoTextPortrait, {
                renderTexture: this.toolTipWheelInfoTexturePortrait,
                clear: true,
            });
            this.renderer.getRenderer().render(toolTipCounterInfoTextPortrait, {
                renderTexture: this.toolTipCounterInfoTexturePortrait,
                clear: true,
            });
            this.renderer.getRenderer().render(toolTipWheelWinText, {
                renderTexture: this.toolTipWheelWinTexture,
                clear: true,
            });
            this.renderer.getRenderer().render(toolTipWheelLoseText, {
                renderTexture: this.toolTipWheelLoseTexture,
                clear: true,
            });
            this.renderer.getRenderer().render(toolTipCounterWinText, {
                renderTexture: this.toolTipCounterWinTexture,
                clear: true,
            });
            this.renderer.getRenderer().render(toolTipCounterLoseText, {
                renderTexture: this.toolTipCounterLoseTexture,
                clear: true,
            });
            DestroyUtil.destroy(toolTipWheelInfoTextLandscape);
            DestroyUtil.destroy(toolTipCounterInfoTextLandscape);
            DestroyUtil.destroy(toolTipWheelWinText);
            DestroyUtil.destroy(toolTipWheelLoseText);
            DestroyUtil.destroy(toolTipCounterWinText);
            DestroyUtil.destroy(toolTipCounterLoseText);
            DestroyUtil.destroy(toolTipWheelInfoTextPortrait);
            DestroyUtil.destroy(toolTipCounterInfoTextPortrait);
            SpineUtil.setSlotTexture(this.animation, ArcadeWheelStyle.ANIM_TOOL_TIP_PANEL_INTRO, ArcadeWheelStyle.ANIM_SLOT_TOOLTIP_TEXT_WHEEL_INFO, [
                this.toolTipWheelInfoTextureLandscape,
                this.toolTipWheelInfoTexturePortrait,
            ]);
            SpineUtil.setSlotTexture(this.animation, ArcadeWheelStyle.ANIM_TOOL_TIP_PANEL_INTRO, ArcadeWheelStyle.ANIM_SLOT_TOOLTIP_TEXT_WHEEL_WIN, [this.toolTipWheelWinTexture, this.toolTipWheelWinTexture]);
            SpineUtil.setSlotTexture(this.animation, ArcadeWheelStyle.ANIM_TOOL_TIP_PANEL_INTRO, ArcadeWheelStyle.ANIM_SLOT_TOOLTIP_TEXT_WHEEL_LOSE, [this.toolTipWheelLoseTexture, this.toolTipWheelLoseTexture]);
            SpineUtil.setSlotTexture(this.animation, ArcadeWheelStyle.ANIM_TOOL_TIP_PANEL_INTRO, ArcadeWheelStyle.ANIM_SLOT_TOOLTIP_TEXT_COUNTER_INFO, [
                this.toolTipCounterInfoTextureLandscape,
                this.toolTipCounterInfoTexturePortrait,
            ]);
            SpineUtil.setSlotTexture(this.animation, ArcadeWheelStyle.ANIM_TOOL_TIP_PANEL_INTRO, ArcadeWheelStyle.ANIM_SLOT_TOOLTIP_TEXT_COUNTER_WIN, [this.toolTipCounterWinTexture, this.toolTipCounterWinTexture]);
            SpineUtil.setSlotTexture(this.animation, ArcadeWheelStyle.ANIM_TOOL_TIP_PANEL_INTRO, ArcadeWheelStyle.ANIM_SLOT_TOOLTIP_TEXT_COUNTER_LOSE, [this.toolTipCounterLoseTexture, this.toolTipCounterLoseTexture]);
        });
    }
    createAnchor() {
        this.anchor = new AbstractView(new AbstractViewProperties());
        this.addChild(this.anchor);
        this.anchor.alpha = 0;
        this.anchor.setTrackingProperties(this.uiProperties.trackingProperties);
    }
    async handleShow() {
        this.dispatchCore(new EventObject(CommonGameEvent.BI_KPI.getType(), {
            category: "SLINGO_STATE",
            operation: "SUPERSPIN_AVAILABLE",
            value: null,
        }));
        const spinPriceParam = new KeyValuePair(SlingoLang.PARAM_AMOUNT, this.formatCurrency(this.model.getGameProgress().getNextStakeToSpin()));
        const spinPriceLabel = this.langManager.getLang(ArcadeWheelLang.SPIN_PRICE);
        const spinPriceLabelReplaced = this.langManager.replaceParameters(spinPriceLabel, [spinPriceParam]);
        this.spinPrice.setText(spinPriceLabelReplaced, true);
        this.tweenInstructions(0, 0);
        if (this.wheelBackground) {
            this.wheelBackground.destroy(true);
            this.wheelBackground = null;
        }
        this.winRatio = this.model.getGameProgress().getNextStakeToSpinChance();
        this.wheelBackground = this.drawWheelBackground(this.winRatio);
        SpineUtil.setSlotTexture(this.animation, ArcadeWheelStyle.ANIM_STATIC_WHEEL, ArcadeWheelStyle.ANIM_SLOT_WHEEL_BACKGROUND, this.wheelBackground);
        this.state = ArcadeWheelState.CLOSED;
        this.updateTracking();
        this.startWheel(false);
        this.actionButton.setEnabled(false);
        this.qButton.setEnabled(false);
        await Promise.all([this.tweenPosition(true), this.tweenVisibility()]);
        await this.startButton(true);
        this.actionButton.setEnabled(true);
        this.qButton.setEnabled(true);
        this.setQButtonStateAnim(ButtonConstants.DEFAULT);
        this.tweenInstructions(1, ArcadeWheelConstants.INSTRUCTIONS_FADE_DURATION);
    }
    async handleReplay() {
        this.updateSpinCounter();
        this.instructionsText.alpha = 0;
        if (this.wheelBackground) {
            this.wheelBackground.destroy(true);
            this.wheelBackground = null;
        }
        this.winRatio = this.model.getGameProgress().getNextStakeToSpinChance();
        this.wheelBackground = this.drawWheelBackground(this.winRatio);
        SpineUtil.setSlotTexture(this.animation, ArcadeWheelStyle.ANIM_STATIC_WHEEL, ArcadeWheelStyle.ANIM_SLOT_WHEEL_BACKGROUND, this.wheelBackground);
        this.state = ArcadeWheelState.CLOSED;
        this.updateTracking();
        await this.animateResetSpinner(ArcadeWheelConstants.RESET_SPINNER_DURATION);
        this.startWheel(false);
        await Promise.all([this.tweenPosition(true), this.tweenVisibility()]);
        this.dispatchGame(CommonGameEvent.SPIN_REQUEST);
    }
    handleHide() {
        this.updateSpinCounter();
        if (this.state !== ArcadeWheelState.HIDDEN) {
            this.dispatchCore(new EventObject(CommonGameEvent.BI_KPI.getType(), {
                category: "SLINGO_STATE",
                operation: "SUPERSPIN_HIDE",
                value: null,
            }));
        }
        this.state = ArcadeWheelState.HIDDEN;
        this.tweenPosition(true);
        this.tweenVisibility();
    }
    handleHelpDialogOpen() {
        this.handleHide();
    }
    handleHelpDialogClose() {
        if (this.model.isStakeToSpin()) {
            this.handleShow();
        }
    }
    handleActionButtonClick() {
        const failedSpins = this.model.getSpinResult()?.getNextStakeToSpin()?.length || 0;
        this.dispatchCore(new EventObject(CommonGameEvent.BI_KPI.getType(), {
            category: "SLINGO_STATE",
            operation: "SUPERSPIN_BUTTON_PRESSED",
            value: JSON.stringify({
                purchaseSpin: this.model?.getGameProgress()?.getPurchaseSpinsUsed() + 1, //1-indexed
                attempt: failedSpins + 1 //1-indexed
            })
        }));
        const spinStart = new Date();
        this.spinStartTime = spinStart.getTime();
        Logger.verbose(`ArcadeWheelSpin start: ${spinStart.getHours()}:${spinStart.getMinutes()}:${spinStart.getSeconds()}.${spinStart.getMilliseconds()}`);
        this.actionButton.setEnabled(false);
        this.qButton.setEnabled(false);
        this.setQButtonStateAnim(ButtonConstants.DISABLED);
        const tweenToolTip = this.state.isToolTip();
        this.state = ArcadeWheelState.OPEN;
        if (tweenToolTip) {
            this.tweenToolTip();
        }
        //this.updateSpinCounter(-1);
        this.startWheel(true);
        this.tweenInstructions(0, ArcadeWheelConstants.INSTRUCTIONS_FADE_DURATION);
        this.tweenPosition(true);
        this.dispatchGame(CommonGameEvent.SPIN_REQUEST);
    }
    handleQButtonClick() {
        if (this.state.isToolTip()) {
            this.state = ArcadeWheelState.CLOSED;
            this.dispatchCore(new EventObject(CommonGameEvent.BI_KPI.getType(), {
                category: "SLINGO_STATE",
                operation: "SUPERSPIN_TOOLTIP_HIDE",
                value: null,
            }));
            this.dispatchGame(ArcadeWheelEvent.TOOLTIP_HIDE);
        }
        else {
            this.state = ArcadeWheelState.TOOLTIP;
            this.dispatchCore(new EventObject(CommonGameEvent.BI_KPI.getType(), {
                category: "SLINGO_STATE",
                operation: "SUPERSPIN_TOOLTIP_SHOW",
                value: null,
            }));
            this.dispatchGame(ArcadeWheelEvent.TOOLTIP_SHOW);
        }
        this.qButtonCallToActionShown = true;
        this.setQButtonStateAnim(ButtonConstants.ROLLOVER);
        this.tweenToolTip();
    }
    async handleStakeToSpinResult() {
        const minSpinDuration = this.model.getGameConfig()?.getMinimumSpinDuration() || 0;
        await this.spinWheel(this.winRatio);
        if (this.model.isWinningStakeToSpin()) {
            this.dispatchGame(ArcadeWheelEvent.WIN);
            this.dispatchGame(SlingoEvent.SPIN_RESULT);
            this.handleHide();
        }
        else {
            this.dispatchGame(ArcadeWheelEvent.LOSE);
            this.state = ArcadeWheelState.CLOSED;
            this.model.setSpinResultResolving(false);
            if (this.model.hasStakeToSpinAttemptsRemaining()) {
                this.dispatchGame(CommonGameEvent.PURCHASE_SPIN);
            }
            if (Service.isReplay()) {
                this.dispatchGame(ArcadeWheelEvent.REPLAY_SPIN_COMPLETE);
            }
            else if (this.model.isComplete() ||
                !this.model.hasStakeToSpinAttemptsRemaining()) {
                this.dispatchGame(ArcadeWheelEvent.GAME_COMPLETE_DISABLE_COLLECT);
                this.state = ArcadeWheelState.HIDDEN;
                this.updateSpinCounter();
                await Promise.all([
                    this.tweenPosition(true),
                    this.tweenVisibility(),
                    this.startButton(true),
                ]);
                if (!this.model.hasStakeToSpinAttemptsRemaining()) {
                    //trigger Arcade Wheel error message indicating out of spins
                    this.dispatchGame(ArcadeWheelEvent.OUT_OF_SPINS);
                }
                else {
                    //trigger updateGame() in controller to end the game
                    this.dispatchGame(ArcadeWheelEvent.MAX_TOTAL_STAKE_EXCEEDED);
                }
                this.tweenPosition(false); //GD-8476
                this.setQButtonStateAnim(ButtonConstants.DISABLED);
                this.setButtonStateAnim(ButtonConstants.DISABLED);
            }
            else {
                this.tweenInstructions(1, ArcadeWheelConstants.INSTRUCTIONS_FADE_DURATION);
                const spinFinish = new Date();
                Logger.verbose(`ArcadeWheelSpin finish: ${spinFinish.getHours()}:${spinFinish.getMinutes()}:${spinFinish.getSeconds()}.${spinFinish.getMilliseconds()}`);
                const spinFinishTime = spinFinish.getTime();
                const timeRemaining = Math.max(0, minSpinDuration - (spinFinishTime - this.spinStartTime) / 1000);
                const buttonEnabler = gsap.delayedCall(timeRemaining, () => {
                    const buttonEnabled = new Date();
                    Logger.verbose(`ArcadeWheelSpin buttonEnabled: ${buttonEnabled.getHours()}:${buttonEnabled.getMinutes()}:${buttonEnabled.getSeconds()}.${buttonEnabled.getMilliseconds()}`);
                    this.actionButton.setEnabled(true);
                });
                await Promise.all([this.tweenPosition(true), this.startButton(true)]);
                this.tweenPosition(false); //GD-8476
                //show button disabled state if minSpinDuration not hit before shrink tween completed
                if (buttonEnabler.isActive()) {
                    this.setButtonStateAnim(ButtonConstants.DISABLED);
                    await buttonEnabler;
                    this.setButtonStateAnim(ButtonConstants.DEFAULT);
                }
                if (this.actionButton.isEnabled()) {
                    this.qButton.setEnabled(true);
                }
            }
        }
    }
    handlePayTableOpen() {
        TitanButton.disableButton(this.qButton);
        TitanButton.disableButton(this.actionButton);
        this.setButtonStateAnim(ButtonConstants.DISABLED);
        this.setQButtonStateAnim(ButtonConstants.DISABLED);
        gsap.killTweensOf(this.instructionsText);
        this.tweenInstructions(0, ArcadeWheelConstants.INSTRUCTIONS_FADE_DURATION);
    }
    handlePayTableClose() {
        if (this.state.isClosed()) {
            TitanButton.enableButton(this.qButton);
            TitanButton.enableButton(this.actionButton);
            this.setButtonStateAnim(ButtonConstants.DEFAULT);
            this.setQButtonStateAnim(ButtonConstants.DEFAULT);
            gsap.killTweensOf(this.instructionsText);
            this.tweenInstructions(1, ArcadeWheelConstants.INSTRUCTIONS_FADE_DURATION);
        }
    }
    handleButtonDown() {
        this.setButtonStateAnim(ButtonConstants.PRESSED);
    }
    handleButtonOver() {
        this.setButtonStateAnim(ButtonConstants.ROLLOVER);
    }
    handleButtonOut() {
        this.setButtonStateAnim(ButtonConstants.DEFAULT);
    }
    handleQButtonDown() {
        this.setQButtonStateAnim(ButtonConstants.PRESSED);
    }
    handleQButtonOver() {
        this.setQButtonStateAnim(ButtonConstants.ROLLOVER);
    }
    handleQButtonOut() {
        this.setQButtonStateAnim(ButtonConstants.DEFAULT);
    }
    handleRotate(event) {
        super.handleRotate();
        this.anchor.setTrackingProperties(this.uiProperties.trackingProperties);
        this.updateSpinCounter();
    }
    handleResize(event) {
        super.handleResize(event);
        this.tweenPosition(false);
    }
    /**
     * Play all the animations for when the player starts the wheel
     */
    startWheel(animate = true) {
        const anim = this.hasSpinCounter()
            ? ArcadeWheelStyle.ANIM_BUTTON_SHRINK
            : ArcadeWheelStyle.ANIM_BUTTON_SHRINK_NO_COUNTER;
        this.resetSpinner();
        this.tweenSpinPrice(0, animate ? ArcadeWheelConstants.BUTTON_TEXT_FADE_DURATION : 0);
        this.animation.clearTrack(0);
        this.animation.clearTrack(1);
        this.animation.getSpine().update(10000); //qButton track doesn't visually clear until the anim finishes
        SpineUtil.gotoAndPlay(this.animation, animate ? 0 : this.getSpineTotalFrames(this.animation, anim), anim, 3);
    }
    /**
     * Play all the animations for when the button appears
     */
    async startButton(animate = true) {
        const actionButtonAnim = this.hasSpinCounter()
            ? ArcadeWheelStyle.ANIM_BUTTON_EXPAND
            : ArcadeWheelStyle.ANIM_BUTTON_EXPAND_NO_COUNTER;
        this.animation.clearTrack(1);
        this.updateSpinCounter();
        if (animate) {
            await new Promise((resolve) => {
                SpineUtil.play(this.animation, actionButtonAnim, () => {
                    //Recheck the wheel state in case the spin was retriggered
                    if (this.state.isClosed()) {
                        this.setButtonStateAnim(this.isActionButtonOver()
                            ? ButtonConstants.ROLLOVER
                            : ButtonConstants.DEFAULT);
                        this.setQButtonStateAnim(ButtonConstants.DEFAULT);
                        this.tweenSpinPrice(1, ArcadeWheelConstants.BUTTON_TEXT_FADE_DURATION);
                    }
                    resolve();
                }, this, 3);
            });
        }
        else {
            SpineUtil.gotoAndPlay(this.animation, this.getSpineTotalFrames(this.animation, actionButtonAnim), actionButtonAnim, 3);
            this.setQButtonStateAnim(ButtonConstants.DEFAULT);
            this.tweenSpinPrice(1, 0);
        }
    }
    /**
     * Sets the appropriate button anim depending on button state
     */
    setButtonStateAnim(state) {
        switch (state) {
            case ButtonConstants.DEFAULT:
                SpineUtil.play(this.animation, ArcadeWheelStyle.ANIM_BUTTON_UP, null, this, 0);
                break;
            case ButtonConstants.DISABLED:
                SpineUtil.play(this.animation, ArcadeWheelStyle.ANIM_BUTTON_DISABLED, null, this, 0);
                break;
            case ButtonConstants.PRESSED:
                SpineUtil.play(this.animation, ArcadeWheelStyle.ANIM_BUTTON_DOWN, null, this, 0);
                break;
            case ButtonConstants.ROLLOVER:
                SpineUtil.play(this.animation, ArcadeWheelStyle.ANIM_BUTTON_OVER, null, this, 0);
                break;
            default:
                throw new Error(`Invalid button state: ${state}`);
        }
    }
    /**
     * Sets the appropriate help button anim depending on button state
     */
    setQButtonStateAnim(state) {
        const toolTipOpen = this.state.isToolTip();
        switch (state) {
            case ButtonConstants.DEFAULT:
                if (this.qButtonCallToActionShown) {
                    SpineUtil.play(this.animation, toolTipOpen
                        ? ArcadeWheelStyle.ANIM_XBUTTON_UP
                        : ArcadeWheelStyle.ANIM_QBUTTON_UP, null, this, 1);
                }
                else if (!this.animIsPlaying(this.animation, ArcadeWheelStyle.ANIM_QBUTTON_CALL_TO_ACTION, 1)) {
                    SpineUtil.playLoop(this.animation, ArcadeWheelStyle.ANIM_QBUTTON_CALL_TO_ACTION, 1);
                }
                break;
            case ButtonConstants.DISABLED:
                SpineUtil.play(this.animation, toolTipOpen
                    ? ArcadeWheelStyle.ANIM_XBUTTON_DISABLED
                    : ArcadeWheelStyle.ANIM_QBUTTON_DISABLED, null, this, 1);
                break;
            case ButtonConstants.PRESSED:
                SpineUtil.play(this.animation, toolTipOpen
                    ? ArcadeWheelStyle.ANIM_XBUTTON_DOWN
                    : ArcadeWheelStyle.ANIM_QBUTTON_DOWN, null, this, 1);
                break;
            case ButtonConstants.ROLLOVER:
                SpineUtil.play(this.animation, toolTipOpen
                    ? ArcadeWheelStyle.ANIM_XBUTTON_OVER
                    : ArcadeWheelStyle.ANIM_QBUTTON_OVER, null, this, 1);
                break;
            default:
                throw new Error(`Invalid button state: ${state}`);
        }
    }
    animIsPlaying(animation, name, track = 0) {
        const trackEntry = animation.getSpine()?.state?.tracks[track];
        const currentAnimName = trackEntry?.animation?.name || "";
        return Array.isArray(name)
            ? name.indexOf(currentAnimName) > -1
            : name === currentAnimName;
    }
    /**
     * Play the animations for opening/closing the tool tip panel
     */
    tweenToolTip() {
        if (this.state.isToolTip()) {
            const animIntro = this.hasSpinCounter()
                ? ArcadeWheelStyle.ANIM_TOOL_TIP_PANEL_INTRO
                : ArcadeWheelStyle.ANIM_TOOL_TIP_PANEL_INTRO_NO_COUNTER;
            SpineUtil.play(this.animation, animIntro, () => {
                this.mouseBlocker.visible = true;
            }, this, 2);
        }
        else {
            const animOutro = this.hasSpinCounter()
                ? ArcadeWheelStyle.ANIM_TOOL_TIP_PANEL_OUTRO
                : ArcadeWheelStyle.ANIM_TOOL_TIP_PANEL_OUTRO_NO_COUNTER;
            this.mouseBlocker.visible = false;
            SpineUtil.play(this.animation, animOutro, null, this, 2);
        }
    }
    /**
     * Tween the visibility of the component if the state is(not) "HIDDEN"
     */
    tweenVisibility() {
        const hide = this.state.isHidden();
        const targetAlpha = hide ? 0 : 1;
        if (this.visibilityTween) {
            this.visibilityTween.kill();
            this.visibilityTweenPromiseResolve();
            this.visibilityTween = null;
            this.visibilityTweenPromise = null;
            this.visibilityTweenPromiseResolve = null;
        }
        this.visibilityTweenPromise = new Promise((resolve) => {
            this.visibilityTweenPromiseResolve = resolve;
        });
        this.visibilityTween = gsap.to(this, {
            pixi: { autoAlpha: targetAlpha },
            duration: hide
                ? ArcadeWheelConstants.OUTRO_SLIDE_DURATION
                : ArcadeWheelConstants.INTRO_SLIDE_DURATION,
            onComplete: () => {
                this.visibilityTweenPromiseResolve();
            },
        });
        return this.visibilityTweenPromise;
    }
    /**
     * Tween the component to the position indicated by the state (open, closed, hidden)
     */
    tweenPosition(animate) {
        this.anchor.updateTracking();
        let targetPos, targetScale;
        switch (this.state) {
            case ArcadeWheelState.OPEN:
                targetPos = this.uiProperties.offsetInProgress;
                targetScale = this.uiProperties.scaleInProgress;
                break;
            case ArcadeWheelState.CLOSED:
            case ArcadeWheelState.TOOLTIP:
                targetPos = this.uiProperties.offsetNotInProgress;
                targetScale = this.uiProperties.scaleNotInProgress;
                break;
            case ArcadeWheelState.HIDDEN:
                targetPos = this.uiProperties.offsetHidden;
                targetScale = this.uiProperties.scaleHidden;
                break;
            default:
                throw new Error(`Invalid ArcadeWheelState: ${this.state.getType()}`);
        }
        const targetPosition = new PIXI.Point(this.anchor.position.x + targetPos.x, this.anchor.position.y + targetPos.y);
        if (this.positionTween) {
            this.positionTween.kill();
            this.positionTweenPromiseResolve();
            this.positionTween = null;
            this.positionTweenPromise = null;
            this.positionTweenPromiseResolve = null;
        }
        this.positionTweenPromise = new Promise((resolve) => {
            this.positionTweenPromiseResolve = resolve;
        });
        this.positionTween = gsap.to(this.container, {
            x: targetPosition.x,
            y: targetPosition.y,
            pixi: {
                scaleX: targetScale.x,
                scaleY: targetScale.y,
            },
            onComplete: () => {
                this.positionTweenPromiseResolve();
            },
            duration: animate ? ArcadeWheelConstants.REPOSITION_DURATION : 0,
        });
        return this.positionTweenPromise;
    }
    /**
     * Checks if a named image asset exists
     * @param id - (e.g. "SpinButton")
     * @param spriteSheet - (e.g "Game")
     */
    imageExists(id, spriteSheet) {
        const possibleImageIds = [id, `${id}0001`, `${id}Up`];
        return (possibleImageIds.findIndex((piid) => this.assetManager.hasFrameId(piid, spriteSheet)) > -1);
    }
    /**
     * Returns the anim duration as a number of 30fps frames
     * @param anim - (e.g. this.animation)
     * @param animName - (e.g. "")
     */
    getSpineTotalFrames(anim, animName) {
        return this.getSpineDuration(anim, animName) * 30;
    }
    /**
     * Returns the anim duration for this orientation in seconds
     * @param anim - (e.g. this.animation)
     * @param animName - (e.g. "")
     */
    getSpineDuration(anim, animName) {
        const panelAnimDuration = SpineUtil.getDuration(anim, animName);
        if (Array.isArray(panelAnimDuration)) {
            return panelAnimDuration[this.renderer.isLandscape() ? 0 : 1];
        }
        return panelAnimDuration;
    }
    /**
     * Returns the 3 points making up the triangle part of the "wedge" of the winning section of the wheel.
     * @param winRatio - win chance as a number between 0 and 1
     */
    getWedgePoints(winRatio) {
        const wedgeRadius = this.uiProperties.wheelRadius * 2;
        const wedgeSize = Math.PI * 2 * winRatio;
        const line0 = new PIXI.Point(wedgeRadius * Math.sin(wedgeSize / 2), -wedgeRadius * Math.cos(wedgeSize / 2));
        const line1 = new PIXI.Point(wedgeRadius * Math.sin(-wedgeSize / 2), -wedgeRadius * Math.cos(-wedgeSize / 2));
        const boundingRect = new PIXI.Rectangle(-this.uiProperties.wheelRadius, -this.uiProperties.wheelRadius, this.uiProperties.wheelRadius * 2, this.uiProperties.wheelRadius * 2);
        const intersection0 = GraphicsUtil.intersectLineRect(new PIXI.Point(), line0, boundingRect)[0];
        const intersection1 = GraphicsUtil.intersectLineRect(new PIXI.Point(), line1, boundingRect)[0];
        return [intersection0, intersection1, new PIXI.Point()];
    }
    /**
     * Creates a background texture for the wheel as a pie chart showing the winning percentage chance, with the winning part centred at the top of the circle.
     * @param winRatio - win chance as a number between 0 and 1
     */
    drawWheelBackground(winRatio) {
        const wheelBackground = new PIXI.Graphics();
        const wheelBackgroundMask = new PIXI.Graphics();
        wheelBackgroundMask.beginFill(0, 1);
        wheelBackgroundMask.drawCircle(0, 0, this.uiProperties.wheelRadius);
        wheelBackgroundMask.endFill();
        wheelBackground.mask = wheelBackgroundMask;
        const points = this.getWedgePoints(winRatio);
        const radius = this.uiProperties.wheelRadius;
        const fillWedge = winRatio > 0.5
            ? this.uiProperties.wheelColourLose
            : this.uiProperties.wheelColourWin;
        const fillNotWedge = winRatio > 0.5
            ? this.uiProperties.wheelColourWin
            : this.uiProperties.wheelColourLose;
        //Fill in background
        wheelBackground.clear();
        wheelBackground.beginFill(fillNotWedge, 1);
        wheelBackground.drawRect(-radius, -radius, radius * 2, radius * 2); //just draw a rect as there is already a circular mask applied
        wheelBackground.endFill();
        //Draw wedge triangle
        wheelBackground.beginFill(fillWedge, 1);
        wheelBackground.moveTo(points[0].x, points[0].y);
        wheelBackground.lineTo(points[1].x, points[1].y);
        wheelBackground.lineTo(points[2].x, points[2].y);
        wheelBackground.lineTo(points[0].x, points[0].y);
        //Fill in "behind" the triangle to complete the wedge
        wheelBackground.drawRect(-radius, winRatio > 0.5 ? points[0].y : points[0].y - radius, radius * 2, radius);
        wheelBackground.endFill();
        return this.renderer.getRenderer().generateTexture(wheelBackground, {
            scaleMode: PIXI.SCALE_MODES.LINEAR,
            resolution: 1.0,
            region: new PIXI.Rectangle(-radius, -radius, radius * 2, radius * 2),
        });
    }
    /**
     * Spin the wheel pointer and land on a random position in the selected segment
     * @param winRatio - odds of winning the spin
     */
    spinWheel(winRatio) {
        const lastStakeToSpin = this.model.getLastStakeToSpin();
        const rng = lastStakeToSpin.getRng();
        const wedgeSize = 360 * winRatio;
        const minAngle = -(wedgeSize / 2);
        let offset = minAngle + (rng.getResult() / rng.getBound()) * 360;
        if (rng.isWin() && Math.abs(offset) + minAngle < 3) {
            offset += offset > 0 ? -3 : 3;
        }
        else {
            //check for spinner ending near edge of wedge
            if (360 + minAngle - offset < 5) {
                offset -= 5;
            }
            //always check both min and max angle in case wedge is very thin
            if (offset + minAngle < 5) {
                offset += 5;
            }
        }
        let finalAngle = ArcadeWheelConstants.SPIN_ROTATION + offset;
        const boneName = ArcadeWheelStyle.ANIM_BONE_WHEEL_POINTER;
        const landscapeBone = this.animation
            .getSpine(OrientationType.LANDSCAPE)
            .skeleton.findBone(boneName);
        const portraitBone = this.animation
            .getSpine(OrientationType.PORTRAIT)
            .skeleton.findBone(boneName);
        const spinner = { rotation: 0 };
        this.dispatchGame(ArcadeWheelEvent.WHEEL_SPIN);
        return gsap.to(spinner, {
            rotation: -finalAngle,
            duration: ArcadeWheelConstants.SPIN_DURATION,
            ease: "power2.inOut",
            onUpdate: function () {
                landscapeBone.rotation = spinner.rotation;
                portraitBone.rotation = landscapeBone.rotation;
            },
        });
    }
    /**
     * Resets the wheel spinner to its default position
     */
    resetSpinner() {
        const boneName = ArcadeWheelStyle.ANIM_BONE_WHEEL_POINTER;
        const landscapeBone = this.animation
            .getSpine(OrientationType.LANDSCAPE)
            .skeleton.findBone(boneName);
        const portraitBone = this.animation
            .getSpine(OrientationType.PORTRAIT)
            .skeleton.findBone(boneName);
        landscapeBone.rotation = 0;
        portraitBone.rotation = 0;
    }
    /**
     * Animates moving the wheel spinner back to its default position
     * @param duration - reset time in seconds
     */
    async animateResetSpinner(duration) {
        const boneName = ArcadeWheelStyle.ANIM_BONE_WHEEL_POINTER;
        const landscapeBone = this.animation
            .getSpine(OrientationType.LANDSCAPE)
            .skeleton.findBone(boneName);
        const portraitBone = this.animation
            .getSpine(OrientationType.PORTRAIT)
            .skeleton.findBone(boneName);
        const spinner = { rotation: landscapeBone.rotation % 360 };
        await gsap.to(spinner, {
            delay: ArcadeWheelConstants.RESET_SPINNER_DELAY,
            rotation: 0,
            duration: duration,
            onUpdate: () => {
                landscapeBone.rotation = spinner.rotation;
                portraitBone.rotation = spinner.rotation;
            },
            ease: Back.easeOut,
        });
    }
    /**
     * Tween the spin price visibility. Clear any existing tweens to avoid GD-8452
     * @param targetAlpha - the visibility 'alpha' value the animation should end with.
     * @param duration - the length of time the transition animation should take. If <= 0 it will happen instantly.
     */
    tweenSpinPrice(targetAlpha, duration) {
        const tweenTime = new Date();
        Logger.verbose(`"ArcadeWheelSpin tweenSpinPrice: ${tweenTime.getHours()}:${tweenTime.getMinutes()}:${tweenTime.getSeconds()}.${tweenTime.getMilliseconds()}`);
        if (this.spinPriceTween) {
            const tweenTime2 = new Date();
            Logger.verbose(`"ArcadeWheelSpin tweenSpinPrice killTween ${this.spinPriceTween.__id}: ${tweenTime2.getHours()}:${tweenTime2.getMinutes()}:${tweenTime2.getSeconds()}.${tweenTime2.getMilliseconds()}`);
            this.spinPriceTween.kill();
            this.spinPriceTween = null;
        }
        if (this.spinCounterTween) {
            this.spinCounterTween.kill();
            this.spinCounterTween = null;
        }
        if (duration > 0) {
            this.spinPriceTween = gsap.to(this.spinPrice, {
                pixi: { autoAlpha: targetAlpha },
                duration: duration,
            });
            const tweenTime3 = new Date();
            this.__tweenID++;
            this.spinPriceTween.__id = this.__tweenID;
            Logger.verbose(`"ArcadeWheelSpin tweenSpinPrice tween ${this.spinPriceTween.__id}, targetAlpha ${targetAlpha}: ${tweenTime3.getHours()}:${tweenTime3.getMinutes()}:${tweenTime3.getSeconds()}.${tweenTime3.getMilliseconds()}`);
            if (this.hasSpinCounter()) {
                this.spinCounterTween = gsap.to(this.spinCounterText, {
                    pixi: { autoAlpha: targetAlpha },
                    duration: duration,
                });
            }
        }
        else {
            this.spinPrice.visible = targetAlpha > 0;
            this.spinPrice.alpha = targetAlpha;
            const tweenTime4 = new Date();
            Logger.verbose(`"ArcadeWheelSpin tweenSpinPrice noTween, targetAlpha ${targetAlpha}: ${tweenTime4.getHours()}:${tweenTime4.getMinutes()}:${tweenTime4.getSeconds()}.${tweenTime4.getMilliseconds()}`);
            if (this.hasSpinCounter()) {
                this.spinCounterText.visible = targetAlpha > 0;
                this.spinCounterText.alpha = targetAlpha;
            }
        }
    }
    /**
     * Tween the instructions. Clears any existing tweens.
     * @param targetAlpha - the visibility 'alpha' value the animation should end with.
     * @param duration - the length of time the transition animation should take. If <= 0 it will happen instantly.
     */
    tweenInstructions(targetAlpha, duration) {
        if (this.instructionsTextTween) {
            this.instructionsTextTween.kill();
            this.instructionsTextTween = null;
        }
        if (duration > 0) {
            this.instructionsTextTween = gsap.to(this.instructionsText, {
                pixi: { autoAlpha: targetAlpha },
                duration: duration,
            });
        }
        else {
            this.instructionsText.visible = targetAlpha > 0;
            this.instructionsText.alpha = targetAlpha;
        }
    }
    /**
     * Check if the mouse pointer is over the button using the button hitArea
     */
    isActionButtonOver() {
        const mouseGlobal = this.renderer.getRenderer()?.plugins?.interaction?.mouse?.global ||
            new PIXI.Point(-1, -1);
        const localClick = this.actionButton.toLocal(mouseGlobal);
        const hitArea = this.actionButton.hitArea;
        return hitArea?.contains(localClick.x, localClick.y);
    }
    /**
     * Check if the spin counter should be shown
     */
    hasSpinCounter() {
        return (this.model.getMaximumStakeToSpinAttempts() > 0 && !Service.isReplay());
    }
    /**
     * Update the spin counter to show remaining attempts
     * @param offset - offset real value by this number if you need to spoof the value before getting a response
     */
    updateSpinCounter(offset = 0) {
        if (this.hasSpinCounter()) {
            const spinsRemaining = this.model.getStakeToSpinAttemptsRemaining();
            const maskBone = this.animation.findBone(ArcadeWheelStyle.ANIM_BONE_COUNTER_MASK);
            const count1OffSet = (ArcadeWheelConstants.COUNTER_MASK_MAX -
                ArcadeWheelConstants.COUNTER_MASK_MIN) *
                (1 / this.model.getMaximumStakeToSpinAttempts());
            this.spinCounterText.setText(`${spinsRemaining + offset}`, true);
            maskBone.y =
                ArcadeWheelConstants.COUNTER_MASK_MIN +
                    count1OffSet * Math.max(0, spinsRemaining - 1);
        }
        else {
            this.spinCounterText.setText("", true);
        }
    }
    /**
     * Finds the top level container of the tooltip and offsets its base position. This is very dependant on the spine structure and is NOT compatible with any change to it.
     */
    hackToolTipPosition() {
        const animIntro = this.hasSpinCounter()
            ? ArcadeWheelStyle.ANIM_TOOL_TIP_PANEL_INTRO
            : ArcadeWheelStyle.ANIM_TOOL_TIP_PANEL_INTRO_NO_COUNTER;
        const animOutro = this.hasSpinCounter()
            ? ArcadeWheelStyle.ANIM_TOOL_TIP_PANEL_OUTRO
            : ArcadeWheelStyle.ANIM_TOOL_TIP_PANEL_OUTRO_NO_COUNTER;
        const slots = [
            this.animation.findSlot(ArcadeWheelStyle.ANIM_SLOT_TOOLTIP_PANEL[0]),
            this.animation.findSlot(ArcadeWheelStyle.ANIM_SLOT_TOOLTIP_PANEL[1]),
        ];
        const props = [
            this.landscapeProperties,
            this.portraitProperties,
        ];
        slots.forEach((slot, index) => {
            this.animation.gotoAndPlay(this.getSpineTotalFrames(this.animation, animIntro[index]), animIntro[index]);
            this.animation.getSpine().update(0);
            const _currentSprite = slot && slot.currentSprite;
            const _csP = _currentSprite && _currentSprite.parent;
            const _csPP = _csP && _csP.parent;
            const topLevelContainer = _csPP && _csPP.parent;
            if (topLevelContainer && props[index]) {
                topLevelContainer.x = props[index].toolTipOffsetProperties.x;
                topLevelContainer.y = props[index].toolTipOffsetProperties.y;
            }
            this.animation.gotoAndPlay(this.getSpineTotalFrames(this.animation, animOutro[index]), animOutro[index]);
        });
    }
}
/**
 * ArcadeWheelProperties.ts
 */
export class ArcadeWheelProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return (super.equals(other) &&
            this.trackingProperties.equals(other.trackingProperties) &&
            this.animationProperties.equals(other.animationProperties) &&
            this.scaleInProgress.equals(other.scaleInProgress) &&
            this.scaleNotInProgress.equals(other.scaleNotInProgress) &&
            this.scaleHidden.equals(other.scaleHidden) &&
            this.offsetInProgress.equals(other.offsetInProgress) &&
            this.offsetNotInProgress.equals(other.offsetNotInProgress) &&
            this.offsetHidden.equals(other.offsetHidden) &&
            this.actionButtonProperties.equals(other.actionButtonProperties) &&
            this.qButtonProperties.equals(other.qButtonProperties) &&
            this.wheelRadius === other.wheelRadius &&
            this.spinPriceProperties.equals(other.spinPriceProperties) &&
            this.instructionsProperties.equals(other.instructionsProperties) &&
            this.instructionsBackgroundProperties.equals(other.instructionsBackgroundProperties) &&
            this.toolTipWheelInfoTextLandscapeProperties.equals(other.toolTipWheelInfoTextLandscapeProperties) &&
            this.toolTipCounterInfoTextLandscapeProperties.equals(other.toolTipCounterInfoTextLandscapeProperties) &&
            this.toolTipWheelInfoTextPortraitProperties.equals(other.toolTipWheelInfoTextPortraitProperties) &&
            this.toolTipCounterInfoTextPortraitProperties.equals(other.toolTipCounterInfoTextPortraitProperties) &&
            this.toolTipWheelWinTextProperties.equals(other.toolTipWheelWinTextProperties) &&
            this.toolTipWheelLoseTextProperties.equals(other.toolTipWheelLoseTextProperties) &&
            this.toolTipCounterWinTextProperties.equals(other.toolTipCounterWinTextProperties) &&
            this.toolTipCounterLoseTextProperties.equals(other.toolTipCounterLoseTextProperties) &&
            this.spinCounterTextProperties.equals(other.spinCounterTextProperties) &&
            this.toolTipOffsetProperties.equals(other.toolTipOffsetProperties));
    }
    setDefaultValues() {
        this.animationProperties = new SpineProperties(ArcadeWheelStyle.ANIMATION, SlingoStyle.MODULE);
        this.animationProperties.forceResponsive = true;
        this.actionButtonProperties = new ButtonProperties(ArcadeWheelStyle.SPRITE_ACTION_BUTTON, SlingoStyle.MODULE, new PIXI.Point(-150, -150));
        this.actionButtonProperties.circleRadius = 150;
        this.qButtonProperties = new ButtonProperties(ArcadeWheelStyle.SPRITE_QUESTION_BUTTON, SlingoStyle.MODULE, new PIXI.Point(209, -315));
        this.qButtonProperties.circleRadius = 55;
        this.trackingProperties = new TrackingProperties(ArcadeWheelStyle.SPIN_BUTTON);
        this.scaleInProgress = new PIXI.Point(1, 1);
        this.scaleNotInProgress = new PIXI.Point(0.6, 0.6);
        this.scaleHidden = new PIXI.Point(0.6, 0.6);
        this.offsetInProgress = new PIXI.Point(102, 206);
        this.offsetNotInProgress = new PIXI.Point(202, 206);
        this.offsetHidden = new PIXI.Point(804, 206);
        this.wheelRadius = 178;
        this.wheelColourLose = 0xee1911;
        this.wheelColourWin = 0x4da718;
        this.spinPriceProperties = new TextFieldProperties(ArcadeWheelStyle.FONT_SPIN_PRICE, new PIXI.Point(150, 35), null, ControlConstants.CENTER, ControlConstants.CENTER, new PIXI.Point(240, 240));
        this.instructionsProperties = new TextFieldProperties(ArcadeWheelStyle.FONT_INSTRUCTIONS, new PIXI.Point(1216, 240), ArcadeWheelLang.PROMPT, ControlConstants.CENTER, ControlConstants.CENTER, new PIXI.Point(800, 600));
        this.instructionsProperties.setMultiline(true);
        this.instructionsBackgroundProperties = new SpineProperties(ArcadeWheelStyle.ANIMATION, SlingoStyle.MODULE, new PIXI.Point(0, 300));
        this.toolTipWheelInfoTextLandscapeProperties = new TextFieldProperties(ArcadeWheelStyle.FONT_TOOLTIP_INFO, new PIXI.Point(241, 0), ArcadeWheelLang.TOOLTIP_TEXT_WHEEL_INFO, ControlConstants.CENTER, ControlConstants.CENTER, new PIXI.Point(483, 178));
        this.toolTipWheelInfoTextLandscapeProperties.setMultiline(true);
        this.toolTipCounterInfoTextLandscapeProperties = new TextFieldProperties(ArcadeWheelStyle.FONT_TOOLTIP_INFO, new PIXI.Point(241, 0), ArcadeWheelLang.TOOLTIP_TEXT_COUNTER_INFO, ControlConstants.CENTER, ControlConstants.CENTER, new PIXI.Point(483, 222));
        this.toolTipCounterInfoTextLandscapeProperties.setMultiline(true);
        this.toolTipWheelInfoTextPortraitProperties = new TextFieldProperties(ArcadeWheelStyle.FONT_TOOLTIP_INFO, new PIXI.Point(704, 0), ArcadeWheelLang.TOOLTIP_TEXT_WHEEL_INFO, ControlConstants.CENTER, ControlConstants.CENTER, new PIXI.Point(1408, 220));
        this.toolTipWheelInfoTextPortraitProperties.setMultiline(true);
        this.toolTipCounterInfoTextPortraitProperties = new TextFieldProperties(ArcadeWheelStyle.FONT_TOOLTIP_INFO, new PIXI.Point(704, 0), ArcadeWheelLang.TOOLTIP_TEXT_COUNTER_INFO, ControlConstants.CENTER, ControlConstants.CENTER, new PIXI.Point(1408, 220));
        this.toolTipCounterInfoTextPortraitProperties.setMultiline(true);
        this.toolTipWheelWinTextProperties = new TextFieldProperties(ArcadeWheelStyle.FONT_TOOLTIP_LABEL, new PIXI.Point(300, 0), ArcadeWheelLang.TOOLTIP_TEXT_WHEEL_WIN, ControlConstants.CENTER, ControlConstants.CENTER, new PIXI.Point(600, 120));
        this.toolTipWheelLoseTextProperties = new TextFieldProperties(ArcadeWheelStyle.FONT_TOOLTIP_LABEL, new PIXI.Point(300, 0), ArcadeWheelLang.TOOLTIP_TEXT_WHEEL_LOSE, ControlConstants.CENTER, ControlConstants.CENTER, new PIXI.Point(600, 120));
        this.toolTipCounterWinTextProperties = new TextFieldProperties(ArcadeWheelStyle.FONT_TOOLTIP_LABEL, new PIXI.Point(300, 0), ArcadeWheelLang.TOOLTIP_TEXT_COUNTER_WIN, ControlConstants.CENTER, ControlConstants.CENTER, new PIXI.Point(600, 120));
        this.toolTipCounterLoseTextProperties = new TextFieldProperties(ArcadeWheelStyle.FONT_TOOLTIP_LABEL, new PIXI.Point(300, 0), ArcadeWheelLang.TOOLTIP_TEXT_COUNTER_LOSE, ControlConstants.CENTER, ControlConstants.CENTER, new PIXI.Point(600, 120));
        this.spinCounterTextProperties = new TextFieldProperties(ArcadeWheelStyle.FONT_COUNTER, new PIXI.Point(416, 367), null, ControlConstants.CENTER, ControlConstants.CENTER, new PIXI.Point(100, 100));
        this.toolTipOffsetProperties = new PIXI.Point(0, 0);
    }
}
/**
 * ArcadeWheelEvent.ts
 */
export class ArcadeWheelEvent {
}
ArcadeWheelEvent.SHOW = new EventObject("ArcadeWheelEvent.SHOW");
ArcadeWheelEvent.HIDE = new EventObject("ArcadeWheelEvent.HIDE");
ArcadeWheelEvent.STAKE_TO_SPIN_RESULT = new EventObject("ArcadeWheelEvent.STAKE_TO_SPIN_RESULT");
ArcadeWheelEvent.WHEEL_SPIN = new EventObject("ArcadeWheelEvent.WHEEL_SPIN");
ArcadeWheelEvent.WIN = new EventObject("ArcadeWheelEvent.WIN");
ArcadeWheelEvent.LOSE = new EventObject("ArcadeWheelEvent.LOSE");
ArcadeWheelEvent.TOOLTIP_SHOW = new EventObject("ArcadeWheelEvent.TOOLTIP_SHOW");
ArcadeWheelEvent.TOOLTIP_HIDE = new EventObject("ArcadeWheelEvent.TOOLTIP_HIDE");
ArcadeWheelEvent.OUT_OF_SPINS = new EventObject("ArcadeWheelEvent.OUT_OF_SPINS");
ArcadeWheelEvent.MAX_TOTAL_STAKE_EXCEEDED = new EventObject("ArcadeWheelEvent.MAX_TOTAL_STAKE_EXCEEDED");
ArcadeWheelEvent.GAME_COMPLETE_DISABLE_COLLECT = new EventObject("ArcadeWheelEvent.GAME_COMPLETE_DISABLE_COLLECT");
ArcadeWheelEvent.REPLAY_SPIN = new EventObject("ArcadeWheelEvent.REPLAY_SPIN");
ArcadeWheelEvent.REPLAY_SPIN_COMPLETE = new EventObject("ArcadeWheelEvent.REPLAY_SPIN_COMPLETE");
/**
 * ArcadeWheelStyle.ts
 */
export class ArcadeWheelStyle {
}
ArcadeWheelStyle.ANIMATION = "ARCADE_WHEEL_ANIM";
ArcadeWheelStyle.SPIN_BUTTON = "ArcadeWheelStyle.SPIN_BUTTON";
ArcadeWheelStyle.SPRITE_ACTION_BUTTON = "ArcadeWheelButton";
ArcadeWheelStyle.SPRITE_QUESTION_BUTTON = "ArcadeWheelQButton";
///anim names
ArcadeWheelStyle.ANIM_STATIC_WHEEL = "WheelSlideInLandscape";
ArcadeWheelStyle.ANIM_BUTTON_SHRINK = [
    "ButtonShrinkLandscapeWithCounter",
    "ButtonShrinkPortraitWithCounter",
];
ArcadeWheelStyle.ANIM_BUTTON_SHRINK_NO_COUNTER = [
    "ButtonShrinkLandscapeWithoutCounter",
    "ButtonShrinkPortraitWithoutCounter",
];
ArcadeWheelStyle.ANIM_BUTTON_EXPAND = [
    "ButtonExpandLandscapeWithCounter",
    "ButtonExpandPortraitWithCounter",
];
ArcadeWheelStyle.ANIM_BUTTON_EXPAND_NO_COUNTER = [
    "ButtonExpandLandscapeWithoutCounter",
    "ButtonExpandPortraitWithoutCounter",
];
ArcadeWheelStyle.ANIM_BUTTON_DISABLED = "ButtonDisabledLandscape";
ArcadeWheelStyle.ANIM_BUTTON_DOWN = "ButtonDownLandscape";
ArcadeWheelStyle.ANIM_BUTTON_OVER = "ButtonOverLandscape";
ArcadeWheelStyle.ANIM_BUTTON_UP = "ButtonUpLandscape";
ArcadeWheelStyle.ANIM_QBUTTON_CALL_TO_ACTION = [
    "ButtonQMarkCallToActionLandscape",
    "ButtonQMarkCallToActionPortrait",
];
ArcadeWheelStyle.ANIM_QBUTTON_DISABLED = [
    "ButtonQMarkDisabledLandscape",
    "ButtonQMarkDisabledPortrait",
];
ArcadeWheelStyle.ANIM_QBUTTON_DOWN = [
    "ButtonQMarkDownLandscape",
    "ButtonQMarkDownPortrait",
];
ArcadeWheelStyle.ANIM_QBUTTON_OVER = [
    "ButtonQMarkOverLandscape",
    "ButtonQMarkOverPortrait",
];
ArcadeWheelStyle.ANIM_QBUTTON_UP = [
    "ButtonQMarkUpLandscape",
    "ButtonQMarkUpPortrait",
];
ArcadeWheelStyle.ANIM_XBUTTON_DISABLED = [
    "ButtonXMarkDisabledLandscape",
    "ButtonXMarkDisabledPortrait",
];
ArcadeWheelStyle.ANIM_XBUTTON_DOWN = [
    "ButtonXMarkDownLandscape",
    "ButtonXMarkDownPortrait",
];
ArcadeWheelStyle.ANIM_XBUTTON_OVER = [
    "ButtonXMarkOverLandscape",
    "ButtonXMarkOverPortrait",
];
ArcadeWheelStyle.ANIM_XBUTTON_UP = [
    "ButtonXMarkUpLandscape",
    "ButtonXMarkUpPortrait",
];
ArcadeWheelStyle.ANIM_TOOL_TIP_PANEL_INTRO = [
    "ToolTipPanelIntroLandscapeWithCounter",
    "ToolTipPanelIntroPortraitWithCounter",
];
ArcadeWheelStyle.ANIM_TOOL_TIP_PANEL_INTRO_NO_COUNTER = [
    "ToolTipPanelIntroLandscapeWithoutCounter",
    "ToolTipPanelIntroPortraitWithoutCounter",
];
ArcadeWheelStyle.ANIM_TOOL_TIP_PANEL_OUTRO = [
    "ToolTipPanelOutroLandscapeWithCounter",
    "ToolTipPanelOutroPortraitWithCounter",
];
ArcadeWheelStyle.ANIM_TOOL_TIP_PANEL_OUTRO_NO_COUNTER = [
    "ToolTipPanelOutroLandscapeWithoutCounter",
    "ToolTipPanelOutroPortraitWithoutCounter",
];
ArcadeWheelStyle.ANIM_TOOL_TIP_PANEL_STATIC = [
    "ToolTipPanelStaticLandscapeWithoutCounter",
    "ToolTipPanelStaticPortraitWithoutCounter",
];
ArcadeWheelStyle.ANIM_TOOL_TIP_PANEL_STATIC_NO_COUNTER = [
    "ToolTipPanelStaticLandscapeWithCounter",
    "ToolTipPanelStaticPortraitWithCounter",
];
ArcadeWheelStyle.ANIM_INSTRUCTIONS_BACKGROUND = "GridOverlay";
//slot / bone names
ArcadeWheelStyle.ANIM_SLOT_WHEEL_BACKGROUND = "Pie";
ArcadeWheelStyle.ANIM_BONE_WHEEL_POINTER = "Arrow";
ArcadeWheelStyle.ANIM_SLOT_TOOLTIP_TEXT_WHEEL_INFO = [
    "ToolTipTextField",
    "toolTipTextFieldPortrait01",
];
ArcadeWheelStyle.ANIM_SLOT_TOOLTIP_TEXT_WHEEL_WIN = [
    "ToolTipTextField3",
    "toolTipTextFieldPortrait05",
];
ArcadeWheelStyle.ANIM_SLOT_TOOLTIP_TEXT_WHEEL_LOSE = [
    "ToolTipTextField4",
    "toolTipTextFieldPortrait06",
];
ArcadeWheelStyle.ANIM_SLOT_TOOLTIP_TEXT_COUNTER_INFO = [
    "ToolTipTextField2",
    "toolTipTextFieldPortrait02",
];
ArcadeWheelStyle.ANIM_SLOT_TOOLTIP_TEXT_COUNTER_WIN = [
    "ToolTipTextField5",
    "toolTipTextFieldPortrait03",
];
ArcadeWheelStyle.ANIM_SLOT_TOOLTIP_TEXT_COUNTER_LOSE = [
    "ToolTipTextField6",
    "toolTipTextFieldPortrait04",
];
ArcadeWheelStyle.ANIM_BONE_COUNTER_MASK = "CounterMask";
ArcadeWheelStyle.ANIM_SLOT_TOOLTIP_PANEL = [
    "ToolTipPanel",
    "ToolTipPanelPortrait",
];
//Font style keys
ArcadeWheelStyle.FONT_SPIN_PRICE = "ArcadeWheelStyle.FONT_SPIN_PRICE";
ArcadeWheelStyle.FONT_INSTRUCTIONS = "ArcadeWheelStyle.FONT_INSTRUCTIONS";
ArcadeWheelStyle.FONT_TOOLTIP_INFO = "ArcadeWheelStyle.FONT_TOOLTIP_INFO";
ArcadeWheelStyle.FONT_TOOLTIP_LABEL = "ArcadeWheelStyle.FONT_TOOLTIP_LABEL";
ArcadeWheelStyle.FONT_COUNTER = "ArcadeWheelStyle.FONT_COUNTER";
ArcadeWheelStyle.FONT_COLOUR = "#FFFFFF";
ArcadeWheelStyle.FONT_STROKE_LARGE = new FontStroke("#000000", 8);
ArcadeWheelStyle.FONT_STROKE_SMALL = new FontStroke("#000000", 4);
ArcadeWheelStyle.FONT_SHADOW_LARGE = new FontShadow("#000000", 0.1, 0, 1, 10);
ArcadeWheelStyle.FONT_SHADOW_SMALL = new FontShadow("#000000", 0.1, 0, 1, 10);
/**
 * ArcadeWheelLang.ts
 */
export class ArcadeWheelLang {
}
//Temp text - DEBUG
ArcadeWheelLang.PROMPT = "ArcadeWheelLang.PROMPT";
ArcadeWheelLang.SPIN_PRICE = "ArcadeWheelLang.SPIN_PRICE";
ArcadeWheelLang.PARAM_MAX_SPINS = "{param.maxSpins}";
ArcadeWheelLang.HELP_PAGE_TITLE = "ArcadeWheelLang.HELP_PAGE_TITLE";
ArcadeWheelLang.HELP_PAGE_MESSAGE = "ArcadeWheelLang.HELP_PAGE_MESSAGE_";
ArcadeWheelLang.TOOLTIP_TEXT_WHEEL_INFO = "ArcadeWheelLang.TOOLTIP_TEXT_WHEEL_INFO";
ArcadeWheelLang.TOOLTIP_TEXT_WHEEL_WIN = "ArcadeWheelLang.TOOLTIP_TEXT_WHEEL_WIN";
ArcadeWheelLang.TOOLTIP_TEXT_WHEEL_LOSE = "ArcadeWheelLang.TOOLTIP_TEXT_WHEEL_LOSE";
ArcadeWheelLang.TOOLTIP_TEXT_COUNTER_INFO = "ArcadeWheelLang.TOOLTIP_TEXT_COUNTER_INFO";
ArcadeWheelLang.TOOLTIP_TEXT_COUNTER_WIN = "ArcadeWheelLang.TOOLTIP_TEXT_COUNTER_WIN";
ArcadeWheelLang.TOOLTIP_TEXT_COUNTER_LOSE = "ArcadeWheelLang.TOOLTIP_TEXT_COUNTER_LOSE";
ArcadeWheelLang.DIALOG_OUT_OF_SPINS = "ArcadeWheelLang.DIALOG_OUT_OF_SPINS";
/**
 * ArcadeWheelConstants.ts
 */
export class ArcadeWheelConstants {
}
//Tweens
ArcadeWheelConstants.INTRO_SLIDE_DURATION = 1;
ArcadeWheelConstants.OUTRO_SLIDE_DURATION = 1;
ArcadeWheelConstants.REPOSITION_DURATION = 1;
ArcadeWheelConstants.INSTRUCTIONS_FADE_DURATION = 0.3;
ArcadeWheelConstants.BUTTON_TEXT_FADE_DURATION = 0.15;
ArcadeWheelConstants.SPIN_DURATION = 2;
ArcadeWheelConstants.SPIN_ROTATION = 360 * 5;
ArcadeWheelConstants.COUNTER_MASK_MAX = 10;
ArcadeWheelConstants.COUNTER_MASK_MIN = -102;
ArcadeWheelConstants.RESET_SPINNER_DELAY = 0.5;
ArcadeWheelConstants.RESET_SPINNER_DURATION = 0.3;
//Sounds
ArcadeWheelConstants.BUTTON_PRESS = SoundManager.createSoundProperties("ARCADE_WHEEL_BUTTON_PRESS", "Game", SoundChannelType.AMBIENT, false);
ArcadeWheelConstants.SPIN_LOSE = SoundManager.createSoundProperties("ARCADE_WHEEL_LOOSE_SPIN", "Game", SoundChannelType.AMBIENT, false);
ArcadeWheelConstants.EXIT = SoundManager.createSoundProperties("ARCADE_WHEEL_WHEEL_EXIT", "Game", SoundChannelType.AMBIENT, false);
ArcadeWheelConstants.ENTRY = SoundManager.createSoundProperties("ARCADE_WHEEL_WHEELENTRY_SOUND", "Game", SoundChannelType.AMBIENT, false);
ArcadeWheelConstants.SPIN = SoundManager.createSoundProperties("ARCADE_WHEEL_WHEELSPIN_SOUND", "Game", SoundChannelType.AMBIENT, false);
ArcadeWheelConstants.SPIN_WIN = SoundManager.createSoundProperties("ARCADE_WHEEL_WIN_SPIN", "Game", SoundChannelType.AMBIENT, false);
/**
 * ArcadeWheelState.ts
 */
export class ArcadeWheelState {
    constructor(type) {
        this.type = type;
    }
    getType() {
        return this.type;
    }
    isHidden() {
        return this === ArcadeWheelState.HIDDEN;
    }
    isClosed() {
        return this === ArcadeWheelState.CLOSED;
    }
    isOpen() {
        return this === ArcadeWheelState.OPEN;
    }
    isToolTip() {
        return this === ArcadeWheelState.TOOLTIP;
    }
}
ArcadeWheelState.HIDDEN = new ArcadeWheelState("HIDDEN");
ArcadeWheelState.CLOSED = new ArcadeWheelState("CLOSED");
ArcadeWheelState.OPEN = new ArcadeWheelState("OPEN");
ArcadeWheelState.TOOLTIP = new ArcadeWheelState("TOOLTIP");
//# sourceMappingURL=ArcadeWheel.js.map